export const route = '';

export const isOpenSideBarChange = 'isOpenSideBarChange';
export const isOpenNavBarChange = 'isOpenNavBarChange';